module.exports = "#title-container {\n  padding-top: 11px; }\n\n#user {\n  margin-top: 78px;\n  font-size: 20px; }\n\n#back {\n  font-size: 20px;\n  font-size: 20px;\n  letter-spacing: 0px;\n  text-align: center;\n  color: #858585; }\n\n#back:hover {\n    font-weight: 500; }\n\n#icon {\n  padding-top: 50px;\n  display: block;\n  margin: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/login/forgot/forgot.component.scss
// module id = ./src/app/shared/components/login/forgot/forgot.component.scss
// module chunks = main